import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { UsuariosPersonalService } from '../usuarios-personal.service';
import { PushNotificationService } from '../pushNotification.service';

/**
 * Service for sending notifications to operators when services change
 * Handles push notification logic for service updates
 * 
 * Category: Integration Service
 * Purpose: Operator notifications, push message formatting
 */
@Injectable()
export class ServiceChangeNotificationService {

  constructor(
    private usuariosPersonalService: UsuariosPersonalService,
    private pushService: PushNotificationService
  ) { }

  /**
   * Sends a push notification to the operator assigned to a route
   * @param ruta - Route object from Corp School
   * @param confirmacionId - Confirmation ID
   * @returns Observable that completes when notification is sent
   */
  notifyOperatorOfChange(ruta: any, confirmacionId: string): Observable<any> {
    return new Observable(observer => {
      if (ruta && ruta.operador && ruta.unidad) {
        const operador = JSON.parse(ruta.operador);
        const pushMessage = this.createChangeNotification(confirmacionId);

        this.usuariosPersonalService.obtenerUsuario(operador.key)
          .valueChanges()
          .take(1)
          .subscribe((personal: any) => {
            if (personal && personal.token) {
              this.pushService.enviarPushCambioTuristico(pushMessage, personal.token);
            }
            observer.next();
            observer.complete();
          });
      } else {
        observer.next();
        observer.complete();
      }
    });
  }

  /**
   * Creates a standardized push notification message for service changes
   * @param confirmacionId - Confirmation ID
   * @returns Push notification object
   */
  private createChangeNotification(confirmacionId: string): any {
    return {
      titulo: 'Una ruta asignada a ti ha tenido un cambio',
      mensaje: `La ruta ID:${confirmacionId} ha tenido cambios. Entra a la App para ver más información.`
    };
  }

  /**
   * Sends notifications to operators of all trips in a service
   * @param viajes - Array of trips
   * @param confirmacionId - Confirmation ID
   */
  notifyAllTripOperators(viajes: any[], confirmacionId: string): void {
    if (!viajes || viajes.length === 0) {
      return;
    }

    viajes.forEach(viaje => {
      if (viaje.operador) {
        const operador = typeof viaje.operador === 'string' 
          ? JSON.parse(viaje.operador) 
          : viaje.operador;

        const pushMessage = this.createChangeNotification(confirmacionId);

        this.usuariosPersonalService.obtenerUsuario(operador.key)
          .valueChanges()
          .take(1)
          .subscribe((personal: any) => {
            if (personal && personal.token) {
              this.pushService.enviarPushCambioTuristico(pushMessage, personal.token);
            }
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/integration/service-change-notification.service.ts